// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/front-page.scss";

// ------------------------------------
// Scripts
// ------------------------------------

import "./components/slick-responsive-offscreen";
import "./components/faq";

$(document).ready(function(){
    $('#btnHousing').hover( function () {
        let $this = $(this);
        $this.closest('section').toggleClass('block-section-head-hovered-housing');
    });
    $('#btnOld').hover( function () {
        let $this = $(this);
        $this.closest('section').toggleClass('block-section-head-hovered-old');
    });
    $('#btnShop').hover( function () {
        let $this = $(this);
        $this.closest('section').toggleClass('block-section-head-hovered-shop');
    });
});

